export const ALL = '*';

export const getSectionType = (seatType) => (seatType === 'stand' ? 'section' : seatType);

export const getBlockedSeatKey = ({
  seatType, section, row, seat,
}) => (
  `${seatType}-${String(section).toUpperCase()}-${row}-${seat}`
);

const buildBlockedSeatEntry = ({
  seatType, section, row, seat,
}) => ({
  seatType,
  section,
  row,
  seat: String(seat),
});

export const getNewBlockedSeats = (existing, incoming) => {
  const existingKeys = new Set(existing.map(getBlockedSeatKey));
  return incoming.filter((entry) => !existingKeys.has(getBlockedSeatKey(entry)));
};

export const mergeBlockedSeats = (existing, incoming) => (
  [...existing, ...getNewBlockedSeats(existing, incoming)]
);

const socketRequest = (socket, event, ...args) => new Promise((resolve) => {
  socket.emit(event, ...args, (result) => resolve(result));
});

export const expandBlockedSelection = async (socket, {
  seatType,
  section,
  row,
  seat,
}) => {
  const sectionType = getSectionType(seatType);

  if (row !== ALL && seat !== ALL) {
    return [buildBlockedSeatEntry({
      seatType, section, row, seat,
    })];
  }

  const rows = row === ALL
    ? await socketRequest(socket, 'getRows', sectionType, section)
    : [row];

  if (!Array.isArray(rows) || !rows.length) {
    return [];
  }

  const rowSeats = await Promise.all(rows.map(async (currentRow) => {
    const seats = seat === ALL
      ? await socketRequest(socket, 'getSeats', sectionType, section, currentRow)
      : [seat];

    if (!Array.isArray(seats)) {
      return [];
    }

    return seats.map((currentSeat) => buildBlockedSeatEntry({
      seatType,
      section,
      row: currentRow,
      seat: currentSeat,
    }));
  }));

  return rowSeats.flat();
};
